(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  (function () {
    if (window.Wishlist) return;

    var STORAGE_KEY = 'boutique_wishlist_items';

    function readStore() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    function writeStore(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      } catch (e) {
        /* localStorage unavailable (private mode, quota, etc.) — fail silently */
      }
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
    }

    window.Wishlist = {
      getAll: function () {
        return readStore();
      },
      has: function (handle) {
        if (!handle) return false;
        return readStore().some(function (item) {
          return item.handle === handle;
        });
      },
      add: function (product) {
        if (!product || !product.handle) return;
        var items = readStore();
        var exists = items.some(function (item) {
          return item.handle === product.handle;
        });
        if (!exists) {
          items.push(product);
          writeStore(items);
        }
      },
      remove: function (handle) {
        if (!handle) return;
        var items = readStore().filter(function (item) {
          return item.handle !== handle;
        });
        writeStore(items);
      },
      // Returns true if the product is now saved, false if it was removed.
      toggle: function (product) {
        if (!product || !product.handle) return false;
        if (this.has(product.handle)) {
          this.remove(product.handle);
          return false;
        }
        this.add(product);
        return true;
      },
      count: function () {
        return readStore().length;
      }
    };

    // Broadcast current state once the DOM is ready so every listener
    // (header bubble, drawer, product cards) starts in sync.
    document.addEventListener('DOMContentLoaded', function () {
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: readStore() } }));
    });
  })();

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  class WishlistDrawer extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = this.querySelector('[data-wishlist-toggle]');
      this.closeBtn = this.querySelector('[data-wishlist-close]');
      this.panel = this.querySelector('[data-wishlist-panel]');
      this.itemsContainer = this.querySelector('[data-wishlist-items]');
      this.countBubble = this.querySelector('[data-wishlist-count]');

      this.toggleBtn.addEventListener('click', this.handleToggleClick.bind(this));
      this.closeBtn.addEventListener('click', this.close.bind(this));

      this.outsideClickHandler = (event) => {
        if (!this.contains(event.target) && !this.panel.hidden) {
          this.close();
        }
      };
      document.addEventListener('click', this.outsideClickHandler);

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) this.close();
      });

      document.addEventListener('wishlist:updated', (event) => {
        this.render(event.detail.items);
      });

      this.render(window.Wishlist ? window.Wishlist.getAll() : []);
    }

    handleToggleClick(event) {
      event.stopPropagation();
      if (this.panel.hidden) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.panel.hidden = false;
      this.toggleBtn.setAttribute('aria-expanded', 'true');
      if (window.Wishlist) this.render(window.Wishlist.getAll());
    }

    close() {
      this.panel.hidden = true;
      this.toggleBtn.setAttribute('aria-expanded', 'false');
    }

    render(items) {
      items = items || [];
      var count = items.length;

      if (this.countBubble) {
        this.countBubble.hidden = count === 0;
        var countText = this.countBubble.querySelector('span[aria-hidden]');
        if (countText) countText.textContent = count;
      }

      if (!this.itemsContainer) return;

      if (count === 0) {
        this.itemsContainer.innerHTML = '<p class="wishlist-drawer__empty">Your wishlist is empty.</p>';
        return;
      }

      var self = this;
      this.itemsContainer.innerHTML = items
        .map(function (item) {
          return (
            '<div class="wishlist-drawer__item" data-handle="' + escapeHtml(item.handle) + '">' +
              '<a href="' + escapeHtml(item.url) + '">' +
                '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" width="60" height="80" loading="lazy">' +
              '</a>' +
              '<div class="wishlist-drawer__item-info">' +
                '<a href="' + escapeHtml(item.url) + '" class="wishlist-drawer__item-title">' + escapeHtml(item.title) + '</a>' +
                '<p class="wishlist-drawer__item-price">' + escapeHtml(item.price) + '</p>' +
              '</div>' +
              '<button type="button" class="wishlist-drawer__remove" data-remove-handle="' + escapeHtml(item.handle) + '" aria-label="Remove from wishlist">&times;</button>' +
            '</div>'
          );
        })
        .join('');

      this.itemsContainer.querySelectorAll('[data-remove-handle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          window.Wishlist.remove(btn.getAttribute('data-remove-handle'));
        });
      });
    }
  }

  customElements.define('wishlist-drawer', WishlistDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function () {
    function currentHandles() {
      if (!window.Wishlist) return [];
      return window.Wishlist.getAll().map(function (item) {
        return item.handle;
      });
    }

    function syncButtons(handles) {
      handles = handles || currentHandles();
      document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
        var isSaved = handles.indexOf(btn.getAttribute('data-handle')) !== -1;
        btn.classList.toggle('is-wishlisted', isSaved);
        btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-wishlist-btn]');
      if (!btn || !window.Wishlist) return;

      event.preventDefault();
      event.stopPropagation();

      var product = {
        handle: btn.getAttribute('data-handle'),
        title: btn.getAttribute('data-title'),
        url: btn.getAttribute('data-url'),
        image: btn.getAttribute('data-image'),
        price: btn.getAttribute('data-price')
      };

      window.Wishlist.toggle(product);
    });

    // Fired by window.Wishlist whenever items change (add/remove from anywhere)
    document.addEventListener('wishlist:updated', function (event) {
      var handles = (event.detail.items || []).map(function (item) {
        return item.handle;
      });
      syncButtons(handles);
    });

    // Initial paint for cards already saved (e.g. returning visitor)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        syncButtons();
      });
    } else {
      syncButtons();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (function () {
    function currentHandles() {
      if (!window.Wishlist) return [];
      return window.Wishlist.getAll().map(function (item) {
        return item.handle;
      });
    }

    function syncButtons(handles) {
      handles = handles || currentHandles();
      document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
        var isSaved = handles.indexOf(btn.getAttribute('data-handle')) !== -1;
        btn.classList.toggle('is-wishlisted', isSaved);
        btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-wishlist-btn]');
      if (!btn || !window.Wishlist) return;

      event.preventDefault();
      event.stopPropagation();

      var product = {
        handle: btn.getAttribute('data-handle'),
        title: btn.getAttribute('data-title'),
        url: btn.getAttribute('data-url'),
        image: btn.getAttribute('data-image'),
        price: btn.getAttribute('data-price')
      };

      window.Wishlist.toggle(product);
    });

    // Fired by window.Wishlist whenever items change (add/remove from anywhere)
    document.addEventListener('wishlist:updated', function (event) {
      var handles = (event.detail.items || []).map(function (item) {
        return item.handle;
      });
      syncButtons(handles);
    });

    // Initial paint for cards already saved (e.g. returning visitor)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        syncButtons();
      });
    } else {
      syncButtons();
    }

    // Related products load via fetch and re-render after page load,
    // so re-sync whenever new cards get injected into the DOM.
    var relatedEl = document.querySelector('product-recommendations');
    if (relatedEl && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        syncButtons();
      });
      observer.observe(relatedEl, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
